import { render, staticRenderFns } from "./resident.vue?vue&type=template&id=619b01ea&scoped=true&"
import script from "./resident.vue?vue&type=script&lang=js&"
export * from "./resident.vue?vue&type=script&lang=js&"
import style0 from "./resident.vue?vue&type=style&index=0&id=619b01ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619b01ea",
  null
  
)

export default component.exports